export default "__VITE_ASSET__BkHjdtLM__"